import React, { useEffect, useState } from "react";
import { getPestPredictions, TFarmDataResponse } from "../../../services/farm.service";
import SpeedoMetersContainer from "./SpeedoMetersContainer";

type TProps = {
  plotId: string;
}

const PestSpeedoMeters: React.FC<TProps> = (props) => {
  const { plotId } = props;

  const [pestPredictions, setPestPredictions] = useState<TFarmDataResponse>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchpestPredictions();
  }, []);

  const fetchpestPredictions = async () => {
    try {
      setIsLoading(true);
      const response = await getPestPredictions(plotId);
      setPestPredictions(response);
    } catch(error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {
        !isLoading && Object.keys(pestPredictions).length > 0 && <SpeedoMetersContainer 
          farmData={pestPredictions}
          speedoMeterFor="pest"
          plotId={plotId}
        />
      }  
    </div>
  );
};

export default PestSpeedoMeters;